import type { FirebaseOptions } from 'firebase/app';

/**
 * Firebase client config. Values come from Vite env vars (VITE_FIREBASE_*),
 * loaded from `.env.dev` for the cloud DEV project and `.env.production`
 * for prod builds.
 */
const env = import.meta.env;

export const firebaseConfig: FirebaseOptions = {
  apiKey: env.VITE_FIREBASE_API_KEY,
  authDomain: env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: env.VITE_FIREBASE_APP_ID,
};
